export { he } from '@payloadcms/translations/languages/he'
